<template>
    <v-card class="text-center pa-4" :width=width flat tile outlined :to="`/${userDetail.username}`">
        <v-avatar color="blue" class="avatar">
            <img v-if="userDetail.avatar_url" :src="userDetail.avatar_url" :alt="userDetail.name">
            <span class="white--text headline" v-else>{{userDetail.name[0]}}</span>
        </v-avatar>
        <v-card-title class="pa-1 mb-1  justify-center username body-2">
            {{userDetail.username}}
        </v-card-title>
        <v-card-subtitle class="pa-1 justify-center card--title-single-line caption mb-2" v-if="userDetail.role" v-html="userDetail.role">
        </v-card-subtitle>
        <v-card-actions class="pa-0 justify-center">
            <btn-follow @followAction="followUser" @unFollowAction="unFollowUser" :loading="followUpdating" :following="userDetail.following"></btn-follow>
        </v-card-actions>
    </v-card>
</template>
<style scoped>
    .avatar {
        border-radius: 50% !important;
    }
    .username {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: center;
        display: block;
    }
</style>
<script>
import userMixin from "@/mixins/mixin-users"
import btnFollow from "@/components/buttons/follow-button.vue"

export default {
    mixins: [userMixin],

    components: {
        btnFollow
    },

    data: () => ({}),

    props: {
        userDetail: Object,
        width: String
    },

    methods: {

        followUser() {
            this.follow(this.userDetail.id)
        },

        unFollowUser() {
            this.unFollow(this.userDetail.id)
        }
    }
}
</script>